<template>
    <div>
        <div class="contentMenu">
            <div class="menuItem" @click="changeSection('act')" :class="{'active': section === 'act'}">Akta informācija</div>
            <div class="menuItem" @click="changeSection('items')" :class="{'active': section === 'items'}">Priekšmeti</div>
        </div>
        <div class="content">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <div class="main">
                <div class="section" v-if="section=='act'">
                    <div class="sectionTitle">Iekšējās kustības akta pamatdati</div>
                    <div class="sectionContent">
                        <div class="subsection">
                            <div class="title">
                                Pamatinformācija
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_type">Veids</label>
                                    <select name="act_type" id="act_type" v-model="act_type" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                        <option value="give">Izsniegšana no krājuma</option>
                                        <option value="receive">Pieņemšana krājumā</option>
                                        <option value="give_with_reference">Izsniegšana no krājuma (papildus akts)</option>
                                        <option value="give_with_reference_extension">Izsniegšana no krājuma (pagarinājums)</option>
                                        <option value="receive_with_reference">Pieņemšana krājumā (papildus akts)</option>
                                        <option value="receive_with_reference_extension">Pieņemšana krājumā (pagarinājums)</option>
                                        <option value="fact_finding">Fakta konstatācijas akts</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="reference_act_id">Pamata akts</label>
                                    <select name="reference_act_id" id="reference_act_id" v-model="reference_act_id" class="form-control"
                                            :disabled="act_type == 'give' || act_type == 'receive' || act_type == 'fact_finding' || !hasPermission(user, 'can_access_all_internal_acts')">
                                        <option :value="null">Nav norādīts</option>
                                        <option v-for="internal in internal_acts" :key="internal.id" :value="internal.id" v-if="internal.id != id">Nr. {{internal.act_number}} / {{normalDate(internal.act_date)}}</option>
                                    </select>
                                    <small class="muted">Tikai papildus aktiem</small>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_number">Akta numurs</label>
                                    <input type="text" id="act_number" v-model="act_number" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label for="act_date">Akta datums</label>
                                    <v-date-picker
                                        v-if="hasPermission(user, 'can_access_all_internal_acts')"
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="act_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                  <input type="text" v-else :value="normalDate(act_date)" class="form-control" disabled>
                                </div>
                            </div>
                            <div class="col-4" v-if="act_type != 'fact_finding'">
                                <div class="form-group">
                                    <label for="due_date">Termiņš</label>
                                    <v-date-picker
                                        v-if="hasPermission(user, 'can_access_all_internal_acts')"
                                        :popover="{ visibility: 'click' }"
                                        mode="single"
                                        v-model="due_date"
                                        :type="'date'"
                                        :locale="'LV'"
                                        color="teal"
                                        :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                    />
                                  <input type="text" v-else :value="normalDate(due_date)" class="form-control" disabled>
                                </div>
                            </div>
                            <div class="col-4" v-if="act_type != 'fact_finding'">
                                <div class="form-group">
                                    <label for="annex_to_the_act">Pielikumi</label>
                                    <textarea type="text" id="annex_to_the_act" v-model="annex_to_the_act" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">{{annex_to_the_act}}</textarea>
                                    <small>Brīvā tekstā</small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="purpose">Mērķis</label>
                                    <input type="text" id="purpose" v-model="purpose" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="notes">Piezīmes</label>
                                    <textarea type="text" id="notes" v-model="notes" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">{{notes}}</textarea>
                                    <small>Tiek attēlots reģistrācijas grāmatā</small>
                                </div>
                            </div>

                        </div>
                        <div v-if="act_type != 'fact_finding'">
                          <div class="subsection">
                              <div class="title">
                                  Pirmās puses dati
                              </div>
                              <div class="actions">
                                  <button class="btn-sm btn-primary" @click="populateFirstPersonWithCurrentUser()" v-if="hasPermission(user, 'can_access_all_internal_acts')">Aizpildīt ar saviem datiem</button>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="first_person_firstname">Vārds</label>
                                      <input type="text" id="first_person_firstname" v-model="first_person_firstname" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="first_person_lastname">Uzvārds</label>
                                      <input type="text" id="first_person_lastname" v-model="first_person_lastname" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="first_person_position">Amats</label>
                                      <input type="text" id="first_person_position" v-model="first_person_position" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                          </div>

                          <div class="subsection">
                              <div class="title">
                                  Otrās puses dati
                              </div>
                              <div class="actions">
                                  <button class="btn-sm btn-primary" @click="populateSecondPersonWithCurrentUser()" v-if="hasPermission(user, 'can_access_all_internal_acts')">Aizpildīt ar saviem datiem</button>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="second_person_firstname">Vārds</label>
                                      <input type="text" id="second_person_firstname" v-model="second_person_firstname" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="second_person_lastname">Uzvārds</label>
                                      <input type="text" id="second_person_lastname" v-model="second_person_lastname" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="second_person_position">Amats</label>
                                      <input type="text" id="second_person_position" v-model="second_person_position" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                          </div>

                          <div class="subsection">
                              <div class="title">
                                  Akta autors
                              </div>
                              <div class="actions">
                                  <button class="btn-sm btn-primary" @click="populateActAuthorWithCurrentUser()" v-if="hasPermission(user, 'can_access_all_internal_acts')">Aizpildīt ar saviem datiem</button>
                              </div>
                          </div>
                          <div class="row">
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="act_author_firstname">Vārds</label>
                                      <input type="text" id="act_author_firstname" v-model="act_author_firstname" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="act_author_lastname">Uzvārds</label>
                                      <input type="text" id="act_author_lastname" v-model="act_author_lastname" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                              <div class="col-4">
                                  <div class="form-group">
                                      <label for="act_author_position">Amats</label>
                                      <input type="text" id="act_author_position" v-model="act_author_position" class="form-control" :disabled="!hasPermission(user, 'can_access_all_internal_acts')">
                                  </div>
                              </div>
                          </div>
                        </div>
                        <hr>
                        <div class="row" v-if="hasPermission(user, 'can_access_all_internal_acts')">
                            <div class="col-12">
                                <button class="btn btn-primary" @click="save()">Saglabāt</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section"  v-if="section=='items'">
                    <div class="sectionTitle">Priekšmeti</div>
                    <div class="sectionContent">
                        <div class="actions" v-if="hasPermission(user, 'can_access_all_internal_acts')">
                            <items-search-component></items-search-component>
                        </div>
                        <table class="table">
                            <thead class="bg-primary text-white">
                            <tr>
                                <th>Attēls</th>
                                <th>Numurs</th>
                                <th>Nosaukums</th>
                                <th>Kolekcija</th>
                                <th>Apraksts</th>
                                <th>Darbības</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/thumb/'+item.featured_image.file_name"></td>
                                <td style="width:120px;">
                                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                                </td>
                                <td><span v-if="item.title">{{item.title.title}}</span></td>
                                <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                                <td>{{item.description}}</td>
                                <td>
                                    <div class="actions">
                                        <item-view-component
                                            :key="'view-component-'+item.id"
                                            :item="item"
                                            :user="user"
                                            :copyrights="copyrights"
                                        ></item-view-component>
                                        <div v-if="hasPermission(user, 'can_access_all_internal_acts')" @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>

                    </div>
                </div>
            </div>
            <div class="sidebar">
                <div class="section">
                    <div class="sectionTitle">Darbības</div>
                    <div class="sectionContent text-center">
                        <div class="col-12" v-if="hasPermission(user, 'can_access_all_internal_acts')">
                            <button class="btn btn-primary" @click="save()">Saglabāt informāciju</button>
                        </div>
                        <hr v-if="hasPermission(user, 'can_access_all_internal_acts')">
                        <a v-if="act_type && act_type != 'fact_finding'" :href="'/internal-acts/generate-act/'+id" class="btn btn-primary" target="_blank" >Ģenerēt aktu</a>
                        <hr v-if="act_type && act_type != 'fact_finding'">
                        <a :href="'/internal-acts/generate-items-list/'+id" class="btn btn-primary" target="_blank" >Ģenerēt priekšmetu sarakstu</a>
                    </div>
                </div>
                <div class="section" v-if="section == 'items' && hasPermission(user, 'can_access_all_internal_acts')">
                    <div class="sectionTitle">Pievienošana</div>
                    <div class="sectionContent">
                        <div class="row">
                            <div class="col-12 text-left">
                                <div class="form-group">
                                    <get-from-external-act></get-from-external-act>
                                </div>
                                <div class="form-group">
                                    <get-from-internal-act></get-from-internal-act>
                                </div>
                                <div class="form-group">
                                    <researchers-lists></researchers-lists>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
              <div class="section" v-if="hasPermission(user,'can_access_all_internal_acts')">

                <div class="sectionTitle">Lietotāju piekļuves</div>
                <div class="sectionContent">
                  <div class="form-group text-center">
                    <button class="btn btn-primary" data-toggle="modal" :data-target="'#modal-permissions'">Piekļuves pārvaldība</button>
                  </div>
                  <div class="modal fade" tabindex="-1"  :id="'modal-permissions'" ref="vuemodal">
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                          <h5 class="modal-title">Piekļuves pārvaldība</h5>
                          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group">
                                <label for="filter">Filtrs</label>
                                <input type="text" class="form-control" v-model="userFilter">
                              </div>
                            </div>
                            <div class="col-12 usersTable">
                              <table class="table">
                                <thead class="bg-primary text-white sticky-top">
                                <tr>
                                  <th>Lietotājs</th>
                                  <th>Var piekļūt un labot aktu</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="person" v-for="user in filteredUsers" :key="user.id">
                                  <td><strong>{{user.firstname}} {{user.lastname}}</strong></td>
                                  <td>
                                    <div v-if="users_can_view.includes(user.id)" class="switch" :class="{'active': (users_can_view.includes(user.id))}" @click="changePermission('remove','can_view', user.id, id)"><span class="circle"></span></div>
                                    <div v-else class="switch" @click="changePermission('add','can_view', user.id, id)"><span class="circle"></span></div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.usersTable
{
  max-height:80vh;
  overflow: auto;
  .switch{
    width:45px;
    height:25px;
    background:#eee;
    border-radius:15px;
    position:relative;
    display:block;
    cursor:pointer;
    .circle{
      position:absolute;
      top:2.5px;
      left:2.5px;
      height:20px;
      width:20px;
      background:#fff;
      border-radius:100%;
      transition:all .2s ease-in-out;
    }
    &.active{
      .circle{
        transform:translateX(17.5px);
        background:$blue;
      }
    }
  }
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.content{
    position:relative;
    display:flex;
    .main{
        flex-basis:800px;
        flex-grow:1;
    }
    .sidebar{
        flex-basis:400px;
        flex-grow:0;
        flex-shrink:0;
        margin-left:30px;
    }
}
.section{
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    margin:15px 0;
    .subsection
    {
        width:100%;
        display:flex;
        align-items: center;
        padding-bottom:5px;
        padding-top:10px;
        border-bottom:solid 5px #eee;
        margin-bottom:15px;
        .title{
            font-size:18px;
            font-weight:bold;
        }
        .actions{
            margin-left:auto;
        }
    }
    hr{
        width:100%;
        display:block;
    }
    .sectionTitle{
        cursor:pointer;
        font-size:16px;
        font-weight: 700;
        text-transform: uppercase;
        padding:15px 20px;
        background-color:$blue;
        color:#fff;
    }
    .sectionContent{
        width:100%;
        padding:10px 20px 20px 20px;
        img{
            width:100px;
            height:auto;
        }
    }
}
</style>

<script>
import ItemViewComponent from "../items/ItemViewComponent";
export default{
    components: { ItemViewComponent},
    props:['act','internal_acts','current_user','user','copyrights','all_users_list'],
    mounted()
    {
        this.items=this.$props.act.items;
        this.id=this.$props.act.id;
        this.reference_act_id=this.$props.act.reference_act_id;
        this.act_type=this.$props.act.act_type;
        this.act_number=this.$props.act.act_number
        this.first_person_firstname=this.$props.act.first_person_firstname;
        this.first_person_lastname=this.$props.act.first_person_lastname;
        this.first_person_position=this.$props.act.first_person_position;
        this.second_person_firstname=this.$props.act.second_person_firstname;
        this.second_person_lastname=this.$props.act.second_person_lastname;
        this.second_person_position=this.$props.act.second_person_position;
        this.purpose=this.$props.act.purpose;
        this.due_date=moment(this.$props.act.due_date, moment.ISO_8601)._d;
        this.act_author_position=this.$props.act.act_author_position;
        this.act_author_firstname=this.$props.act.act_author_firstname;
        this.act_author_lastname=this.$props.act.act_author_lastname;
        this.act_date=moment(this.$props.act.act_date, moment.ISO_8601)._d;
        this.annex_to_the_act=this.$props.act.annex_to_the_act;
        this.notes=this.$props.act.notes;
        this.users=this.$props.act.users;

        var that = this;
        EventBus.$on('add_item_to_list',item_id =>{
            axios.post('/internal-acts/add-item-to-list/'+that.id,
                {
                    item_id: item_id
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.act.items;
                    that.$toast.open(response.data.message);
                }
                if(response.data.status == 'info')
                {
                    that.$toast.warning(response.data.message);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.warning(response.data.message);
                }
            });
        });
        EventBus.$on('add_items_to_list',items_ids =>{
            axios.post('/internal-acts/add-items-to-list/'+that.id,
                {
                    items_ids: items_ids
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.act.items;
                    that.$toast.open(response.data.message);
                }
            });
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });
    },
    methods:{
        changePermission(action,permission_type, user_id, act_id)
        {
          var that = this;
          axios.post('/internal-acts/changePermission/'+act_id,{
            'user_id': user_id,
            'action': action,
            'permission_type': permission_type
          })
              .then(response => {
                if(response.data.status == 'ok')
                {
                  that.users = response.data.users;
                  that.$toast.open(response.data.message);
                }
              })
        },
        hasPermission(user,permission)
        {

          return user.allpermissions.some(function(p) {
            return p.name == permission;
          });
        },
        changeSection(section)
        {
            this.section = section;
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
                if(this.pagination.current_page+1 <= this.pagination.total_page_count)
                {
                    this.search(this.pagination.current_page+1);
                }

            }
        },
        normalDateTime(date)
        {
            if(date != null) {
                return moment(date).format('DD.MM.YYYY. HH:mm')
            }
            else
            {
                return null;
            }
        },
        normalDate(date)
        {
            if(date != null) {
                return moment(date).format('DD.MM.YYYY.')
            }
            else
            {
                return null;
            }
        },
        populateFirstPersonWithCurrentUser()
        {
            this.first_person_firstname = this.$props.current_user.firstname;
            this.first_person_lastname = this.$props.current_user.lastname;
            this.first_person_position = this.$props.current_user.position;
        },
        populateSecondPersonWithCurrentUser()
        {
            this.second_person_firstname = this.$props.current_user.firstname;
            this.second_person_lastname = this.$props.current_user.lastname;
            this.second_person_position = this.$props.current_user.position;
        },
        populateActAuthorWithCurrentUser()
        {
            this.act_author_firstname = this.$props.current_user.firstname;
            this.act_author_lastname = this.$props.current_user.lastname;
            this.act_author_position = this.$props.current_user.position;
        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/internal-acts/remove-item-from-list/' + that.id,
                            {
                                item_id: item_id
                            }).then(response => {
                            if (response.data.status == 'ok') {
                                that.items = response.data.act.items;
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'info') {
                                that.$toast.warning(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                that.$toast.warning(response.data.message);
                            }
                        });
                    }});
        },

      save()
      {
          var that = this;
          var data = {
              reference_act_id: this.reference_act_id,
              act_type: this.act_type,
              act_number: this.act_number,
              first_person_firstname: this.first_person_firstname,
              first_person_lastname: this.first_person_lastname,
              first_person_position: this.first_person_position,
              second_person_firstname: this.second_person_firstname,
              second_person_lastname: this.second_person_lastname,
              second_person_position: this.second_person_position,
              purpose: this.purpose,
              due_date: this.due_date,
              act_author_position: this.act_author_position,
              act_author_firstname: this.act_author_firstname,
              act_author_lastname: this.act_author_lastname,
              act_date: this.act_date,
              annex_to_the_act: this.annex_to_the_act,
              notes: this.notes
          }
          axios.post('/internal-acts/update/'+that.id, data).then(response =>{
              if(response.data.status == 'ok')
              {
                  that.loading = false;
                  that.$toast.open(response.data.message);
              }
              else {
                  that.$toast.error(response.data.message);
              }
          });

      }
    },
    data()
    {
        return{
            id:"",
            reference_act_id:null,
            act_type:null,
            act_number:"",
            first_person_firstname:"",
            first_person_lastname:"",
            first_person_position:"",
            second_person_firstname:"",
            second_person_lastname:"",
            second_person_position:"",
            purpose:"",
            due_date:"",
            act_author_position:"",
            act_author_firstname:"",
            act_author_lastname:"",
            act_date:"",
            annex_to_the_act:"",
            notes:"",
            items:[],
            loading:false,

            section:"act",
            userFilter:"",
            users:[],

        }
    },
    computed:{
        users_can_view: function(user)
        {
          var users = [];
          if(this.users)
          {
            this.users.forEach(user =>
            {
              if(user.permission_type == 'can_view')
              {
                users.push(user.user_id);
              }
            });
          }
          return users;
        },
        users_can_edit: function(user)
        {
          var users = [];
          if(this.users) {
            this.users.forEach(user => {
              if (user.permission_type == 'can_edit') {
                users.push(user.user_id);
              }
            });
          }
          return users;
        },
        filteredUsers:function()
        {
          var filterString = this.userFilter.toLowerCase();
          return this.all_users_list.filter(function(s) {
            if (s.firstname.toLowerCase().includes(filterString) ||
                s.lastname.toLowerCase().includes(filterString) ||
                filterString == ""
            )
            {
              return true;
            }
          });


        },
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        }

    }
}
</script>
